import Area from './area';
import Base from './baseChart';
import Bar from './bar';
import Bubble from './bubble';
import Column from './column';
import Line from './line';
import Map from './map';
import Number from './number';
import Pie from './pie';
import Progress from './progress';
import Radial from './radial';
import Sparkline from './sparkline';
import Spline from './spline';

const charts = {
  Area,
  Bar,
  Bubble,
  Column,
  Line,
  Map,
  Number,
  Pie,
  Progress,
  Radial,
  Sparkline,
  Spline,
};

const chartTypes = Object.keys(charts);

const getChartType = (type) =>
  charts[`${type.charAt(0).toUpperCase()}${type.substr(1).toLowerCase()}`];

/**
 * Chart Types
 * Charts types are subcomponents of the base chart.
 * To use, specify chart type as <Chart.{chart type}> => e.g. <Chart.Bar>
 */
const Chart = Object.assign(Base, { ...charts, chartTypes, getChartType });

export default Chart;
